import * as a from "react";
const t = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M12.78 4.925L10.075 2.22a.76.76 0 00-.53-.22H3.75a.75.75 0 00-.75.75v10.5a.75.75 0 00.75.75h9a.25.25 0 00.25-.25V5.455a.76.76 0 00-.22-.53zM6.91 7.59l-1.685-.63A1.27 1.27 0 014.5 5.725 1.265 1.265 0 015.645 4.46a.125.125 0 00.105-.125V4a.5.5 0 111 0v.315a.125.125 0 00.125.125H7.5a.5.5 0 110 1H5.94c-.44 0-.44.215-.44.285-.008.11.024.22.09.31l1.685.63A1.27 1.27 0 018 7.9a1.265 1.265 0 01-1.145 1.265.125.125 0 00-.105.125v.335a.5.5 0 11-1 0v-.31a.125.125 0 00-.125-.125H5a.5.5 0 110-1h1.56C7 8.19 7 7.97 7 7.9a.465.465 0 00-.09-.31zm4.34 1.785a.375.375 0 010 .75h-2.5a.375.375 0 110-.75h2.5zM9.375 7.5a.38.38 0 01.375-.375h1.5a.375.375 0 010 .75h-1.5a.38.38 0 01-.375-.375zm1.875 4.125a.375.375 0 010 .75h-5a.375.375 0 110-.75h5z",
      fill: "#333"
    }
  )
), v = t;
export {
  v as default
};
